export default function Logo({ dark = false, size = "md", onClick }) {
  const h = size === "lg" ? 44 : size === "sm" ? 30 : 36;
  return (
    <span
      onClick={onClick}
      className={`inline-flex items-center gap-2.5 select-none ${onClick ? "cursor-pointer" : ""}`}
      data-testid="alsat67-logo"
    >
      <svg width={h} height={h} viewBox="0 0 100 100" aria-hidden="true">
        <rect width="100" height="100" rx="24" fill="#FF4D36" />
        <circle cx="76" cy="24" r="7" fill="#FAF9F6" />
        <text x="46" y="70" fontFamily="Outfit, sans-serif" fontWeight="900" fontSize="52" fill="white" textAnchor="middle">
          67
        </text>
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-display font-black tracking-tight ${dark ? "text-bone" : "text-coal"}`} style={{ fontSize: h * 0.5 }}>
          Alsat<span className="text-coral">67</span>
        </span>
        <span className={`font-mono ${dark ? "text-bone/60" : "text-slate-500"}`} style={{ fontSize: Math.max(9, h * 0.17) }}>
          ZONGULDAK 2. EL
        </span>
      </span>
    </span>
  );
}
